import classNames from 'classnames'
import React from 'react'
import { useResultsContext } from '../context/context'
import './ResultsTable.scss'

interface Props {
  id: string
  fadeIn?: boolean
  key?: number
  noborder?: boolean
}

const ResultsTable: React.FC<Props> = ({ children, fadeIn, id, key, noborder }) => {
  const context = useResultsContext()
  return <table
    key={'tableRender' + key}
    id={id}
    className={classNames('results-table', {
      'fade-in': !context.noAnimations && fadeIn,
      'results-table-no-animations': context.noAnimations,
      'noborder': noborder
    })}
  >{children}
  </table>
}

export default ResultsTable
